// extracted by mini-css-extract-plugin
export default {"cropImage":"bTFRytvkEUx5NjZs2zF0"};